/**
 * SIN - Preserve marketing query parameters
 *
 * assets/base.js (Bondfire's webpack bundle) rewrites the PDP URL on load via
 * setActiveVariantId(), building it as `pathname + "?variant=" + id` and
 * discarding the entire existing query string - utm_*, fbclid, gclid,
 * smsclickid, etc. Fires on every PDP, not just on swatch clicks.
 *
 * This wraps history.replaceState / pushState and merges the inbound
 * marketing params back in. base.js reads window.history at call time, so the
 * patch takes effect as long as this loads before base.js.
 *
 * Note: assets/theme.js (older ONYX code) already does this correctly via
 * theme.utils.updateQueryStringParameter. base.js just doesn't use it.
 *
 * Added 2026-07-20. Remove by deleting the <script> tag in layout/theme.liquid.
 */
(function () {
  'use strict';

  var KEEP = [
    'smsclickid', 'fbclid', 'gclid', 'gbraid', 'wbraid', 'msclkid',
    'ttclid', 'twclid', 'li_fat_id', 'rdt_cid', 'irclickid', 'epik',
    'sccid', 'mc_cid', 'mc_eid', '_kx', 'ref', 'referrer'
  ];

  var saved = {};

  try {
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      var k = key.toLowerCase();
      if (k.indexOf('utm_') === 0 || KEEP.indexOf(k) !== -1) {
        saved[key] = value;
      }
    });
  } catch (e) {
    return;
  }

  var keys = Object.keys(saved);
  if (!keys.length) return;

  function merge(url) {
    try {
      var next = new URL(url, window.location.href);
      if (next.origin !== window.location.origin) return url;

      var present = [];
      next.searchParams.forEach(function (v, k) {
        present.push(k.toLowerCase());
      });

      keys.forEach(function (key) {
        if (present.indexOf(key.toLowerCase()) === -1) {
          next.searchParams.set(key, saved[key]);
        }
      });

      return next.pathname + next.search + next.hash;
    } catch (e) {
      return url;
    }
  }

  ['replaceState', 'pushState'].forEach(function (method) {
    var original = window.history[method];
    if (typeof original !== 'function') return;

    window.history[method] = function (state, title, url) {
      if (typeof url === 'string' && url.length) {
        url = merge(url);
      }
      return original.call(window.history, state, title, url);
    };
  });
})();